import type { Post } from "@/entities/post";
import type { ThreadView } from "@/entities/thread";
import { isPostVisible } from "@/features/thread/utils/threadPosts";

/**
 * 拡張向けsnapshotが `getThread({ ng: true })` で返す posts を組み立てる。
 *
 * 画面(VirtualizedDesktopPostList)の除外パイプラインの前半2段だけを再現する。
 * post:beforeRender は通さない(他拡張の挙動に結果が左右されないため)。
 * showNgContent は無視する(除去が目的の呼び出しでON時に効かないと意味がないため)。
 *
 * 何も除外されなければ引数と同じ参照を返す。呼び出し側の Object.is 比較を
 * 安定させ、内部snapshotとの取り違えを防ぐ。
 *
 * replyCount はサーバー値のまま触らない。元々OPを含まない値で posts.length と
 * 意味が違い、除外件数で辻褄合わせをするとかえって壊れる。
 */
export function filterThreadForSnapshot(
  thread: ThreadView,
  isPostHidden: (post: Post) => boolean,
): ThreadView {
  const filtered = thread.posts.filter(
    (post) => isPostVisible(post.status) && !isPostHidden(post),
  );
  if (filtered.length === thread.posts.length) return thread;
  return { ...thread, posts: filtered };
}
